import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Form, Input, Select, Button, Divider, Row, Col, DatePicker,Upload, Table } from 'antd';
import { BiArrowBack } from "react-icons/bi";
import { createUser, resetState } from "../features/students/studentSlice";
import { getStates } from "../features/statecity/statecitySlice";
import { getBrands, getJobtrades } from "../features/brand/brandSlice";
import { getSchools } from "../features/schools/schoolSlice";
import { UploadOutlined,DownloadOutlined } from '@ant-design/icons';
import "./AddStudent.css";
import { base_url } from "../utils/baseUrl";
import Papa from "papaparse";
import FileSaver from "file-saver";

const { Option } = Select;

const AddStudent = () => {
  const statelistState = useSelector((state) => state.statecity.statelist);
  const classlistState = useSelector((state) => state.brand.brands);
  const jobtradelistState = useSelector((state) => state.brand.jobtrades);
  const schoolState = useSelector((state) => state.school.schools);
  const studentState = useSelector((state) => state.student);
  const { isSuccess, isError, isLoading, message, errorMessage, createdcustomers } = studentState;

  const [selectedState, setSelectedState] = useState('');
  const [selectedStateName, setSelectedStateName] = useState('');
  const [fileList, setFileList] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState('');
  const [selectedSchoolId, setSelectedSchool] = useState('');
  const [selectedSchoolName, setSelectedSchoolName] = useState('');
  const [districtOptions, setDistrictOptions] = useState([]);
  const [schoolsOptions, setSchoolsOptions] = useState([]);
  const [hiddenInputValue, setHiddenInputValue] = useState('');
  const [csvData, setCsvData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingtwo, setLoadingtwo] = useState(false);


  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  useEffect(() => {
    dispatch(getStates());
    dispatch(getJobtrades());
    dispatch(getBrands());
    dispatch(getSchools());
  }, [dispatch]);

  useEffect(() => {
    console.log("Print Selected School Data --- ",selectedState);
    if (selectedState) fetchDistricts(selectedState);
    if (selectedState) fetchSchools(selectedState);

  }, [selectedState]);

  const handleStateChange = (value) => {
    const [state_id, state_name] = value.split("|");
    setSelectedState(state_id);
    setSelectedStateName(state_name);

    
    setHiddenInputValue(value);
  };

  const handleDistrictChange = (value) =>{
    setSelectedDistrict(value);
  }

  const handleSchoolChange = (value) =>{
    const [schoolId, school_name] = value.split("|");
    setSelectedSchool(schoolId);
    setSelectedSchoolName(school_name);

  }

  const fetchDistricts = async (stateCode) => {
    const vtfilterData = statelistState.filter((district) => district.state === stateCode);
    setDistrictOptions(vtfilterData);
  };

  const fetchSchools = async (stateCode) => {
    const schoolfilterData = schoolState.filter((school) => school.state_code === stateCode);
    setSchoolsOptions(schoolfilterData);
  };

  const handleFileUpload = (info) => {
    const file = info.file.originFileObj || info.file;

    if (!file) {
      toast.dismiss();
      toast.error("Failed to load file. Please try again.", {
        autoClose: 10000,
      });
      return;
    }

    if (file.type !== "text/csv" && file.type !== "application/vnd.ms-excel") {
      toast.error("Please upload a CSV file.", { autoClose: 5000 });
      return;
    }

    Papa.parse(file, {
      header: true,
      complete: (results) => {
        const headers = results.meta.fields;
        const requiredColumns = [
          "Class",
          "Job_role",
          "Section",
          "Roll_Number",
          "Student_name",
          "Dob",
          "Phone_no",
          "Guardian_name",
          "Student_address"
        ];
        const missingColumns = requiredColumns.filter(
          (column) => !headers.includes(column)
        );

        if (missingColumns.length > 0) {
          toast.dismiss();
          toast.error(
            `Missing required columns: ${missingColumns.join(", ")}`,
            { autoClose: 10000 }
          );
          return;
        }

        const columns = headers.map((header) => ({
          title: header,
          dataIndex: header,
          key: header,
        }));

        setColumns(columns);
        setCsvData(results.data);
        toast.dismiss();
        toast.success("CSV file loaded successfully.", { autoClose: 5000 });
      },
      error: (error) => {
        toast.dismiss();
        toast.error("Failed to parse file.", { autoClose: 5000 });
      },
    });
  };

  const handleSubmit = () => {
    setLoadingtwo(true); 
    if (csvData.length === 0) {
      toast.dismiss();
      toast.error("Please upload the CSV File Before Submitting.", {
        autoClose: 5000,
      });
     setLoadingtwo(false); 
      return;
    }

    const userinfo = localStorage.getItem("user");
    if (!userinfo) {
      toast.dismiss();
      toast.error("User information not found. Please log in again.", {
        autoClose: 5000,
      });
     setLoadingtwo(false); 
      return;
    }

    const userData = JSON.parse(userinfo);
    const token = userData.token;

    if (!token) {
      toast.dismiss();
      toast.error("Token not found in local storage.", { autoClose: 5000 });
      setLoadingtwo(false); 
      return;
    }

    const data = {
      state_code: selectedState,
      state_name : selectedStateName,
      district: selectedDistrict,
      selectedSchoolId: selectedSchoolId,
      selectedSchoolName: selectedSchoolName,
      csvData: csvData,
    };

    fetch(`${base_url}student/upload-student`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 'fail') {
          toast.error(data.message, {
            autoClose: 5000,
          });
        setLoadingtwo(false); 

        } else {
          toast.dismiss();
          toast.success("Student Import Successfully!", {
            autoClose: 5000,
          });
          setLoadingtwo(false); 
          // Handle any additional logic after successful upload, e.g., reset form
          form.resetFields();
          setCsvData([]);
          setColumns([]);
        }
      })
      .catch((error) => {
        toast.dismiss();
        setLoadingtwo(false); 
        toast.error("File upload failed.", { autoClose: 10000 });
      });
  };

  const downloadStudentCsv = () => {
    FileSaver.saveAs(
      `${process.env.PUBLIC_URL}/sample_download/Student_Sample.csv`,
      "Student_Sample.csv"
    );
  };

  const onFinish = (values) => {
    setLoading(true); 
    const [State, State_name] = values.State.split("|");

    const modifiedValues = {
      ...values,
      State,
      State_name,
    };
    dispatch(createUser(modifiedValues));
    setTimeout(() => {
      dispatch(resetState());
      setLoading(false); 

    }, 300);
  };

  useEffect(() => {
    if (isSuccess && createdcustomers) {
      toast.dismiss();
      toast.success("Student Added Successfully!", { autoClose: 5000 });
      navigate("/admin/students");
    }
    if (isError) {
      toast.dismiss();
      toast.error(errorMessage, { autoClose: 5000 });
    }
  }, [isSuccess, isError, errorMessage, isLoading]);

  const dataSectionSet = [
    { key: '1', value: 'A'},
    { key: '2', value: 'B'},
    { key: '3', value: 'C'},
    { key: '4', value: 'D'},
    { key: '5', value: 'E'},
  ];

  return (
    <div className="container">
    <Button
        type="link"
        onClick={() => navigate(-1)}
        style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem', color: '#4a90e2' }}
      >
        <BiArrowBack /> Go Back
      </Button>

      <div className="form-section">
        <h4>Create Student</h4>
        <Form
          form={form}
          name="register"
          onFinish={onFinish}
          initialValues={{ prefix: '+91' }}
          scrollToFirstError
        >
          <Row gutter={16}>
            <Col span={12}>
              
              <Form.Item
                name="State"
                rules={[{ required: true, message: 'Please select a state!' }]}
              >
                <Select placeholder="Select State" onChange={handleStateChange}>
                  {statelistState.map((state, index) => (
                    <Option key={index}  value={`${state.code}|${state.state_name}`}>{state.state_name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="District"
                rules={[{ required: true, message: 'Please select a district!' }]}
              >
                <Select placeholder="Select District" disabled={!selectedState}>
                  {districtOptions.map((district, index) => (
                    district.district_name.map((districtName, idx) => (
                      <Option key={index * 1000 + idx} value={districtName}>{districtName}</Option>
                    ))
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="School"
                rules={[{ required: true, message: 'Please select a school!' }]}
              >
                <Select placeholder="Select School">
                {schoolState.map((i, j) => (
                    <Option key={j} value={i.school_name}>
                      {i.school_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="Class"
                rules={[{ required: true, message: 'Please select a class!' }]}
              >
                <Select placeholder="Select Class">
                {classlistState.map((cls, index) => (
                
                  <Option key={cls.title} value={cls.title}>{cls.title}</Option>
              
              ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
         
          <Col span={8}>
              <Form.Item
                name="Section"
               
              >
                <Select placeholder="Select Section">
                {dataSectionSet.map((sec, index) => (
                
                  <Option key={sec.value} value={sec.value}>{sec.value}</Option>
              
              ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
            
              <Form.Item
                name="Job_role"
                rules={[{ required: true, message: 'Please select a Job Trade!' }]}
              >
                <Select placeholder="Select Job Trade">
                {jobtradelistState.map((trade, index) => (
                
                  <Option key={trade.title}  value={trade.title}>{trade.title}</Option>
              
              ))}
                </Select>
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item
                name="Roll_Number"
                rules={[{ required: true, message: 'Please input the roll number!' }]}
              >
                <Input placeholder="Student Roll No." />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="Student_name"
                rules={[{ required: true, message: 'Please input the full name!' }]}
              >
                <Input placeholder="Student Full Name" />
              </Form.Item>
            </Col>
            <Col span={10}>
              <Form.Item
                name="Dob"
                rules={[{ required: true, message: 'Please input the date of birth!' }]}
              >
                <DatePicker placeholder="Student DOB" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="Phone_no"
                rules={[
                  { required: true, message: 'Please input the mobile number!' },
                  { pattern: /^[0-9]{10}$/, message: 'Mobile number must be 10 digits!' }
                ]}
              >
                <Input placeholder="Mobile No." />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="Guardian_name"
                rules={[{ required: true, message: 'Please input the guardian name!' }]}
              >
                <Input placeholder="Student Guardian Name" />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={24}>
              <Form.Item
                name="Student_address"
                rules={[{ required: true, message: 'Please input the address!' }]}
              >
                <Input placeholder="Student Address" />
              </Form.Item>
            </Col>
          </Row>
          <Button type="primary" htmlType="submit" loading={loading}>Create Student</Button>
        </Form>
      </div>
      <Divider />


      <div className="form-section">
      <Button
            type="primary"
            className="exportcsv"
            onClick={downloadStudentCsv}
          >
            <DownloadOutlined /> Sample Student
          </Button>
        <h4>Bulk Student Import</h4>
        
        <Form>
          <Row gutter={16}>
            <Col span={12}>
              
              <Form.Item
                name="State"
                rules={[{ required: true, message: 'Please select a state!' }]}
              >
                <Select placeholder="Select State" onChange={handleStateChange}>
                  {statelistState.map((state, index) => (
                    <Option key={index}  value={`${state.code}|${state.state_name}`}>{state.state_name}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="District"
                rules={[{ required: true, message: 'Please select a district!' }]}
              >
                <Select placeholder="Select District" disabled={!selectedState} onChange={handleDistrictChange}>
                  {districtOptions.map((district, index) => (
                    district.district_name.map((districtName, idx) => (
                      <Option key={index * 1000 + idx} value={districtName}>{districtName}</Option>
                    ))
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="School"
                rules={[{ required: true, message: 'Please select a school!' }]}
              >
                <Select placeholder="Select School" onChange={handleSchoolChange}>
                {schoolsOptions.map((i, j) => (
                    <Option key={j} value={`${i._id}|${i.school_name}`}>
                      {i.school_name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="importClass">
                 <Upload 
                accept=".csv"
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleFileUpload}
                showUploadList={true}
                >
                <Button icon={<UploadOutlined />}>Click to Upload</Button>
              </Upload>
              </Form.Item>
            </Col>

          </Row>

          <Button type="primary" onClick={handleSubmit} loading={loadingtwo}> Import Bulk Students </Button>
        </Form>

      </div>
      {csvData.length > 0 && (
          <div style={{ marginTop: "20px" }}>
            <h5>Uploaded Studnet CSV Sheet Preview</h5>
            <Table
              columns={columns}
              dataSource={csvData}
              rowKey={(record, index) => index}
              scroll={{ x: 400 }}
            />
          </div>
        )}

    </div>
  );
};

export default AddStudent;
